import React from "react";
import { colorName } from "../../../components/formComponents/CommonFunctions";
import { Badge } from "antd";
export const column = [
  { key: '1', headerName: 'S.No', field: 'id', hide: false, width: 60 },
  { key: '2', headerName: 'Outlet Code', field: 'outlet_code', hide: false, width: 110 },
  { key: '3', headerName: 'Outlet Name', field: 'outlet_name', hide: false, width: 250 },
  { key: '4', headerName: 'Outlet Type', field: 'outlet_type', hide: false, width: 130 },
  { key: '5', headerName: 'Channel', field: 'channel', hide: false, width: 100 },
  { key: '6', headerName: 'Category', field: 'category', hide: false, width: 130 },
  { key: '7', headerName: 'Consumable Code', field: 'consumable_code', hide: false, width: 150,},   
  { key: '8', headerName: 'Consumable Name', field: 'consumable_name', hide: false, width: 280,},   
  { key: '9', headerName: 'Qty', field: 'qty', hide: false, width: 60,},  
  { key: '10', headerName: 'Status', field: 'status', hide: false, width: 80,
  renderCell: (params) => {
    return (
      <Badge
        style={{ backgroundColor: colorName(params.row.status) }}
        count={params.row.status}
      ></Badge>
    );
  }},   
];
